import React from 'react';
import { connect } from 'react-redux';
import { DataTable, Icon } from '../../widgets';
import { groupBy } from '../../../helpers/common';
import { QAPP_ROLE_ID } from '../../../constants';

const RoleList = (props) => {
    const { roleListById, isRequesting, userListById, activeRoleId, setActiveRoleId } = props;
    const groupByRoleId = groupBy('role_id')(Object.values(userListById));

    return <><DataTable className="role-list">
        <DataTable.Header>
            <DataTable.Row>
                <DataTable.Cell style={{ width: "40px" }}>#</DataTable.Cell>
                <DataTable.Cell>Role</DataTable.Cell>
                <DataTable.Cell>Users</DataTable.Cell>
            </DataTable.Row>
        </DataTable.Header>
        <DataTable.Body>
            {Object.keys(roleListById)
                .filter(roleId => parseInt(roleId) !== QAPP_ROLE_ID)
                .map((roleId, i) =>
                    <DataTable.Row
                        key={roleId}
                        className={activeRoleId === parseInt(roleId) ? "active" : ""}
                        style={{ cursor: "pointer" }}
                        onClick={() => setActiveRoleId(activeRoleId !== parseInt(roleId) ? parseInt(roleId) : null)}>
                        <DataTable.Cell style={{ width: "40px" }}>{i + 1}</DataTable.Cell>
                        <DataTable.Cell >
                            <Icon className="fa fa-user" />
                            <span className="pl-2">{roleListById[roleId].role_name}</span>
                        </DataTable.Cell>
                        <DataTable.Cell>{groupByRoleId[roleId] ? groupByRoleId[roleId].length : 0}</DataTable.Cell>
                    </DataTable.Row>)}
        </DataTable.Body>
    </DataTable>
        {isRequesting ? <DataTable.Loading /> :
            Object.keys(roleListById).length === 0 && <DataTable.RecordsNotFound />}
    </>
}

const mapStateToProps = state => ({
    isRequesting: state.users.roleListById.isRequesting,
    roleListById: state.users.roleListById.payload,
    userListById: state.users.userListById.payload
});

export default connect(mapStateToProps)(RoleList);